module.exports = __webpack_public_path__ + "media/src/pages/Onboarding/images/relax-0871c655f726716ffa41d82d868cd5c1.png";